import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoTooltip from "../../../../common/components/functional/InfoTooltip/InfoTooltip";
import { StyledFormSection } from "../styles";
import LabelInputRow from "./LabelInputRow";

const InvoiceReferencesSection = () => {
  const { t } = useTranslation("customers");

  const Tooltip = (
    <Grid item marginLeft="18px" marginBottom="5px" zIndex={1}>
      <InfoTooltip title={t("contract.invoiceReferencesTooltip")} />
    </Grid>
  );
  return (
    <StyledFormSection
      title={t("contract.invoiceReferences")}
      infoTooltip={Tooltip}
    >
      <LabelInputRow
        label={t("contract.orderReference")}
        fieldName="orderIdentifier"
      />
      <LabelInputRow
        label={t("contract.agreementReference")}
        fieldName="agreementIdentifier"
      />
      <LabelInputRow
        label={t("contract.sellerReference")}
        fieldName="sellerReferenceIdentifier"
      />
      <LabelInputRow
        label={t("contract.buyerReference")}
        fieldName="buyerReferenceIdentifier"
      />
    </StyledFormSection>
  );
};

export default InvoiceReferencesSection;
